import { Button } from "@shared/components/ui/button";
import {
  useDeleteImportedPackage,
  usePackagesImportedUpdate,
  useSaveToPackages,
} from "../hooks/usePackages";
import { CheckCheckIcon, Save, Trash2 } from "lucide-react";

const ImportedPackageActions = ({ id, packageData }) => {
  const { isPending, mutate } = usePackagesImportedUpdate();
  const { isPending: savePending, mutate: saveToPackages } =
    useSaveToPackages();
  const { isPending: deletePending, mutate: deletePackage } =
    useDeleteImportedPackage();
  const handleUpdate = async () => {
    mutate({ id, values: packageData.data });
  };
  const handleDelete = async () => {
    deletePackage(id);
  };
  const handleSaveToPackages = async () => {
    saveToPackages(id);
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={handleUpdate}
        size="icon"
        variant="secondary"
        disabled={isPending}
      >
        <CheckCheckIcon />
      </Button>
      <Button
        onClick={handleSaveToPackages}
        size="icon"
        variant="outline"
        disabled={savePending}
      >
        <Save />
      </Button>
      <Button
        onClick={handleDelete}
        variant="destructive"
        size="icon"
        disabled={deletePending}
      >
        <Trash2 />
      </Button>
    </div>
  );
};

export default ImportedPackageActions;
